import { Bar, Line } from "react-chartjs-2"

import { chartColors, chartTextColor, commonChartOptions } from "./chartConfig"
import { ChartCard, Legend, Section, type SelectOption, SelectPill } from "./components"
import { type EnterpriseChartData, selectOptions } from "./dashboardData"

import styles from "./index.module.scss"

type Props = {
  contractorOptions: SelectOption[]
  isContractorsLoading: boolean
  thermostatChartOption: string
  contractorId: string
  installsOverTimeData: EnterpriseChartData<"line">
  installedVsOrderedData: EnterpriseChartData<"line">
  mobileAppVsCustomersData: EnterpriseChartData<"bar">
  onThermostatChartOptionChange: (option: string) => void
  onContractorChange: (option: string) => void
}

export const ThermostatsWidget = ({
  contractorOptions,
  isContractorsLoading,
  thermostatChartOption,
  contractorId,
  installsOverTimeData,
  installedVsOrderedData,
  mobileAppVsCustomersData,
  onThermostatChartOptionChange,
  onContractorChange,
}: Props) => (
  <Section
    title="Thermostats"
    controls={
      <>
        <SelectPill
          options={selectOptions.sevenDays}
          value={thermostatChartOption}
          onChange={onThermostatChartOptionChange}
        />
        <SelectPill
          options={contractorOptions}
          value={contractorId}
          disabled={isContractorsLoading}
          onChange={onContractorChange}
        />
      </>
    }
  >
    <ChartCard title="Installed Over Time">
      <div className={styles.largeChart}>
        <Line data={installsOverTimeData} options={commonChartOptions} />
      </div>
    </ChartCard>
    <ChartCard title="Installed vs Ordered Trend">
      <div className={styles.largeChart}>
        <Line data={installedVsOrderedData} options={commonChartOptions} />
      </div>
      <Legend
        items={[
          { label: "Installed", color: chartColors.active },
          { label: "Ordered", color: chartColors.ordered },
        ]}
      />
    </ChartCard>
    <ChartCard title="Mobile app vs Customers">
      <div className={styles.largeChart}>
        <Bar data={mobileAppVsCustomersData} options={commonChartOptions} />
      </div>
      <Legend
        items={[
          { label: "Customers", color: chartTextColor },
          { label: "Mobile App", color: chartColors.mobileApp },
        ]}
      />
    </ChartCard>
  </Section>
)
